import { instance, endpoint } from 'api'

export default {
  postClearCache () {
    return instance().post(endpoint + '/clearcache')
  }
}



// WEBPACK FOOTER //
// ./src/api/clearcache/index.js